/* eslint-disable */
/**
 * Redirect the plural form of `reports` to `report`
 * @export
 */
export const REPORT_PLURAL_PAGE_REDIRECT = `/report/:reportType`;

/**
 * The path of the `ReportPage` to be consumed by a `<Router />`
 * @export
 */
export const REPORT_PAGE_PATH = `/report/:reportType`;

/**
 * Create a `href` that will resolve to `ReportPage`
 * @export
 * @param {{ reportType: string }} params The dynamic params that need to be matched
 * @returns {string} The `REPORT_PAGE_PATH`
 */
export const createReportPageLink = ({ reportType }) => `/report/${reportType}`;

/**
 * Determine if the current page is the `ReportPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `ReportPage`
 */
export const isReportPage = (match) => match.path === REPORT_PAGE_PATH;
